import React from 'react';

// Logo resmi YPPSDP (PPSDP) - lingkaran dengan huruf PPSDP dan tulisan
// YAYASAN + PENGEMBANGAN POTENSI SUMBER DAYA PERTAHANAN
const YppsdpLogo = ({ size = 56, className = '' }) => (
  <img
    src="/assets/ppsdp-logo.png"
    alt="Logo YPPSDP - Yayasan Pengembangan Potensi Sumber Daya Pertahanan"
    width={size}
    height={size}
    className={`object-contain ${className}`}
    style={{ width: size, height: size }}
  />
);

export default YppsdpLogo;
